'use strict';

angular.module('shiftTraderApp')
  .directive('saShiftTradeLineItem', function () {
    return {
      templateUrl: 'views/directives/saShiftTradeLineItem.html',
      restrict: 'A',
      scope: {
        trade:'=shiftTrade',
        me:'=loggedInUser'
      },
      controller: ['$scope', '$uibModal', function ($scope, $uibModal) {
        $scope.prompt = function(mode) {
          var options = {
            size: 'md',
            templateUrl: 'views/promptTrade.html',
            controller: 'promptTradeDialogCtrl',
            resolve: {
              trade: function() {
                return $scope.trade;
              },
              myWorkPeriods: ['WorkPeriods', function (WorkPeriods) {
                if (mode === 'accept' || mode === 'decline' && $scope.trade.$isGiveaway()) {
                  var data = {
                    user_id: $scope.me.id
                  };
                  data.start_time = moment($scope.trade.work_period.start_time).subtract(1,'days').format();
                  data.end_time = moment($scope.trade.work_period.end_time).add(1,'days').format();
                  return WorkPeriods.getAll(data); // TODO: make this more specific!! Really just need the day of the shift being accepted/rejected
                } else {
                  return [];
                }
              }],
              mode: function() {
                var a = {};
                a.mode = mode;
                return a;
              },
              me: function() {
                return $scope.me;
              }
            }
          };
          options.resolve.mode[mode] = true;

          var modalInstance = $uibModal.open(options);
          modalInstance.result.then(function (result) {
            if (angular.isDefined(result) && result !== 'close') {
              $scope.trade.shift_trade_responses.push(result);
            }
          }, function(reason) {
            console.log('promptTrade dialog dismissed for reason ' + reason);
          });
        };
      }]
    };
  });
